<template>
  <div class="big">
    <div class="page_title">处方用语设置</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <div>
            <el-menu :default-active="activeIndex"
                     class="el-menu-demo noneline"
                     mode="horizontal"
                     @select="handleSelect">
              <el-menu-item index="1"
                            class="title"
                            style="font-size:16px">主诉</el-menu-item>
              <el-menu-item index="2"
                            class="title space"
                            style="font-size:16px">诊断/适应病症</el-menu-item>
              <el-menu-item index="3"
                            class="title space"
                            style="font-size:16px">煎法</el-menu-item>
              <el-menu-item index="4"
                            class="title space"
                            style="font-size:16px">用法</el-menu-item>
              <el-menu-item index="5"
                            class="title space"
                            style="font-size:16px">禁忌</el-menu-item>
            </el-menu>
          </div>
          <div class="box">
            <div class="component">
              <component :is="currentComponent" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ZhuSu from './ZhuSu';
import ZhenDuan from './ZhenDuan';
import JianFa from './JianFa';
import YongFa from './YongFa';
import JinJi from './JinJi';

export default {
  data() {
    return {
      activeIndex: '1',
      active: ''
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return ZhuSu;
        case '2':
          return ZhenDuan;
        case '3':
          return JianFa;
        case '4':
          return YongFa;
        case '5':
          return JinJi;
        default:
          return ZhuSu;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
